var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g({attrs:{"value":_vm.value,"items":_vm.items,"loading":_vm.loading,"disabled":_vm.loading,"item-text":"name","item-value":"id","label":"Publicación","name":"publication","validation":"required"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }